import { Reveal } from "@/components/Reveal";

export default function PolicyPage({ title, intro, sections, testid }) {
  return (
    <div className="py-14 lg:py-20 pb-24" data-testid={testid}>
      <div className="max-w-[820px] mx-auto px-5 lg:px-10">
        <Reveal>
          <p className="eyebrow mb-3">MIORA</p>
          <h1 className="font-serif font-light text-5xl lg:text-6xl text-ink">{title}</h1>
          <p className="mt-5 text-ink/65 leading-relaxed max-w-xl">{intro}</p>
        </Reveal>

        <div className="mt-14 space-y-10">
          {sections.map((s, i) => (
            <Reveal key={i}>
              <div className="border-s-2 border-rose/40 ps-6" data-testid={`${testid}-section-${i}`}>
                <div className="flex flex-wrap items-center gap-3 mb-2">
                  <h2 className="font-serif font-light text-2xl text-ink">{s.title}</h2>
                  {s.placeholder && (
                    <span className="inline-flex items-center rounded-full bg-rose/12 text-rose-deep text-[10.5px] uppercase tracking-[0.12em] px-3 py-1 border border-rose/30" data-testid={`${testid}-placeholder-badge-${i}`}>
                      {s.placeholder}
                    </span>
                  )}
                </div>
                <p className="text-ink/70 text-[15px] leading-relaxed">{s.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  );
}
